module.exports = __webpack_public_path__ + "static/sideroll-189c5004aaae0c19efd8d293edceecdc.jpg";